const kk = {
  // Navbar
  nav_features: "Мүмкіндіктер",
  nav_howItWorks: "Қалай жұмыс істейді",
  nav_download: "Жүктеу",
  nav_signIn: "Кіру",
  nav_downloadApp: "Қолданбаны жүктеу",
  nav_partners: "Серіктестерге",

  // Hero
  hero_badge: "Жаһандық төлемдер · Тікелей",
  hero_titleAccent: "Сіздің жетілдірілген",
  hero_title2: "сандық әмияныңыз",
  hero_subtitle: "150+ елде лезде ақша жіберіп, алыңыз және айырбастаңыз. Шексіз, найзағай жылдамдықта, толық бақылау.",
  hero_downloadFree: "Тегін жүктеу",
  hero_seeHow: "Қалай жұмыс істейді",
  hero_activeUsers: "Белсенді пайдаланушылар",
  hero_services: "сервистер",
  hero_appRating: "App Store",
  hero_recentActivity: "Соңғы операциялар",
  hero_topUp: "Толтыру",
  hero_send: "Жіберу",
  hero_exchange: "Айырбастау",
  hero_history: "Тарих",
  hero_verifiedSecure: "Тексерілген және қорғалған",
  hero_today: "бүгін",
  hero_usdBalance: "USD Балансы",
  hero_eurBalance: "EUR Балансы",
  hero_btc: "BTC",
  hero_kztBalance: "KZT Балансы",
  hero_tx1: "Сервисті толтыру",
  hero_tx2: "Джоннан алынды",
  hero_tx3: "EUR → USD",
  hero_tx4: "Максимнен алынды",
  hero_minAgo: "2 мин бұрын",
  hero_hrAgo: "1 сағ бұрын",
  hero_hrsAgo: "3 сағ бұрын",

  // Features
  feat_badge: "Неліктен BroMoney",
  feat_title1: "Қажет нәрсенің бәрі,",
  feat_titleAccent: "артығы жоқ",
  feat_subtitle: "Жылдам, қауіпсіз, ыңғайлы.",
  feat_instant_title: "Жылдам аударымдар",
  feat_instant_desc: "5 минуттан 48 сағатқа дейін — аудару әдісіне байланысты.",
  feat_services_title: "Сервистерге төлем",
  feat_services_desc: "Жүздеген сервисті бір рет басумен төлеңіз — коммуналдық, жазылымдар, интернет және т.б.",
  feat_multicurrency_title: "Мультивалюта және крипто",
  feat_multicurrency_desc: "Әр түрлі блокчейн желілерінде криптовалюталар, USDT және фиат — бір әмиянда.",
  feat_security_title: "Қорғаныс",
  feat_security_desc: "Транзакциялар мен деректерді сенімді шифрлау. Қаражатыңыз 24/7 қорғауда.",
  feat_app_title: "Мобильді қосымша",
  feat_app_desc: "iOS және Android үшін толық функционалды нативті қосымшалар.",
  feat_popular: "Танымал",

  // Usage Flow
  flow_badge: "Қалай жұмыс істейді",
  flow_title1: "Дайын болу",
  flow_titleAccent: "3 қарапайым қадамда",
  flow_subtitle: "Кідіріссіз. Ақшаны басқарудың жақсы жолы.",
  flow_step1_title: "Тіркелгі жасаңыз",
  flow_step1_desc: "2 минутта тіркеліңіз. Жылдам верификация — және әмиян дайын.",
  flow_step2_title: "Ақшаны қауіпсіз сақтаңыз",
  flow_step2_desc: "BroMoney — сенімді сандық сейф. Басқа сервистен шығарып толтырыңыз және қаражатыңызды кез келген уақытта бақылаңыз.",
  flow_step3_title: "Жіберіңіз және төлеңіз",
  flow_step3_desc: "Аударыңыз, валюта конвертациялаңыз және сервистерге төлеңіз — жылдам.",
  flow_avgSetup: "Орташа тіркеу уақыты:",
  flow_2min: "2 минут",
  flow_support: "Қолдау қызметі",
  flow_supportTime: "11:00-ден 02:00-ге дейін (GMT+5)",
  flow_fundProtected: "Қаражат қорғалған",

  // Personal/Business
  pb_badge: "Серіктестер",
  pb_title1: "Бизнес және серіктестік",
  pb_contactBusiness: "Бизнес бойынша бізге жазыңыз",
  pb_reviews_title: "Пайдаланушыларымыз не дейді",
  pb_reviews_rating: "4,9 / 5 · 2 400+ пікір",
  review1_text: "Тамаша әмиян — криптода да, фиатта да жылдам шығарамын. Бағамдар тиімді, мұндай жағдайды бұрын кездестірмегенмін. Халықаралық аударымдармен жұмыс жасайтындарға ұсынамын.",
  review2_text: "Интерфейс таза және интуитивті, бірден түсінікті. Қолдау жылдам және нақты жауап береді. Күнде қолданамын — өте ыңғайлы.",
  review3_text: "Сервистерге төлем — керемет. Ақшаны сақтауға, қажет болғанда аккаунттарға аударуға ыңғайлы. Қауіпсіз және нағыз құтқарушы.",

  // CTA
  cta_badge: "Бүгін бастаңыз — Тегін",
  cta_title1: "Сіздің ақшаңыз,",
  cta_title2: "сізбен бірге",
  cta_subtitle: "Жылдам, қауіпсіз және шексіз төлемдер үшін BroMoney-ге сенетін мыңдаған пайдаланушыға қосылыңыз.",
  cta_downloadOn: "Жүктеу",
  cta_appStore: "App Store",
  cta_downloadApk: "Жүктеу",
  cta_android: "Android",
  cta_getItOn: "Алу",
  cta_googlePlay: "Google Play",
  cta_rating: "App Store-де 4.9 рейтинг",
  cta_bankSecurity: "Банктік деңгейдегі қауіпсіздік",
  cta_noHidden: "Жасырын алымдар жоқ",
  cta_account: "Жеке кабинет",

  // Footer
  footer_desc: "Лезде жаһандық төлемдер, аударымдар және айырбастау үшін сіздің жетілдірілген сандық әмияныңыз.",
  footer_goToWallet: "Әмиянға өту",
  footer_downloadAppStore: "App Store-тен жүктеу",
  footer_downloadApk: "APK жүктеу",
  footer_downloadGooglePlay: "APK жүктеу (Google Play)",
  footer_copyright: "BroMoney. Барлық құқықтар қорғалған.",
  footer_regulated: "BroMoney ЕО PSD2 директивасы бойынша реттеледі. FCA лицензиясымен.",
  footer_privacy: "Құпиялық саясаты",
  footer_terms: "Пайдаланушы келісімі",

  // Language names
  lang_ru: "Русский",
  lang_kk: "Қазақша",
  lang_uz: "O'zbekcha",
  lang_en: "English",
};

export default kk;
